<template>
  <div>
    <v-toolbar>

      <v-list-item>
        <v-list-item-content>

          <v-list-item-title class="text-h5">
            {{page.name}}
            
            <template v-if="page.showBeehiveIcon">
              <BeehiveIcon :link="articleLinks[page.articleLink]" />
            </template>
          </v-list-item-title>

          <template v-if="page.breadcrumbs.length>0">
            <v-list-item-subtitle class="text-caption">
              <template v-for="(bc,bci) in page.breadcrumbs">
                <a :class="`${(bc.disabled)?'disabled':''} breadcrumbBtn`" :key="bci" href="#" @click.middle="onMiddleClickBreadCrumbTo(bc)" @click.prevent="breadCrumbTo(bc)">{{bc.text}}</a>
              </template>
            </v-list-item-subtitle>
          </template>
          
        </v-list-item-content>
      </v-list-item>

      <v-spacer></v-spacer>

      <TopMenu v-if="page.type!=='blank'" :pageType="page.type" @menuItemClick="topMenuClicked" @open-search="openSearch" :additionalButtons="page.additionalButtons" @add-button="emitAddButton"/>

      <template v-if="page.showSearch">
        <SearchDialog :searchOpen="searchOpen" @close-search="closeSearch" />
      </template>

    </v-toolbar>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import SearchDialog from './SearchDialog';
  import TopMenu from './TopMenu';
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';
  import { articleLinks } from '@/helpers/links';
  const URL = process.env.VUE_APP_URL || `https://crm-bonline-testing.appspot.com/`;

  export default {
    components: {SearchDialog,TopMenu, BeehiveIcon},

    props: {page: { type: Object }},

    data() {
      return {
        searchOpen: false,
        articleLinks,
      }
    },
    methods: {
      ...mapActions('globals', ['getRecentlyViewed']),
      openSearch() {
        this.getRecentlyViewed();
        this.searchOpen = true;
      },
      closeSearch() { this.searchOpen = false; },
      breadCrumbTo(bc) {
        if(!bc.disabled){
          this.$router.push(bc.href);
        }
      },
      onMiddleClickBreadCrumbTo(bc) {
        if(!bc.disabled){
          window.open(`${URL}${bc.href.substring(1, bc.href.length)}`);
        }
      },
      topMenuClicked(menuItem){
        this.$emit('menuItemClick',menuItem);
      },
      emitAddButton(addBtn){
        this.$emit('addBtnClick',addBtn);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-toolbar {
    position: relative;
    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 100%;
      height: 5px;
      bottom: -5px;
      left: 0;
      background: linear-gradient(90deg, #42CCCC 0%, #363847 100.15%, rgba(255, 255, 255, 0) 100.16%, #363847 100.16%);
    }
  }
  .breadcrumbBtn {
    display: inline-block;
    padding-right: 5px;
    &.disabled {
      color: grey !important;
      cursor: default !important;
    }
    &:after {
      content: '/';
      display: inline-block;
      padding-right: 5px;
      padding-left: 5px;
      color: grey !important;
    }
    &:last-child {
      &:after {
        content: '';
      }
    }
  }
</style>
